module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-desktop-7c01ad154b6d7c20e66ef0382fa2eda1.png";